
<template>
<div>

  <service-view-right-menu-faqs :service_id="service_id" :company_id="company_id" :company_name="company_name" ></service-view-right-menu-faqs>

  <service-view-right-menu-videos :service_id="service_id"></service-view-right-menu-videos>

</div>
</template>

<script>

import {getServiceVideos} from "@/modules/CustomerPortal/api/services/view";
export default {
  name: "ServiceViewRightMenuFaqsVideos",
  components: {getServiceVideos},
  props: [
    "service_id",
    "company_id",
    "company_name"
  ],
  data() {
    return {

    }
  },
  methods:{

  },
  computed: {

  },
  mounted(){

  }
}
</script>

<style scoped>
#videos iframe {
  border-radius: 5px;
}
</style>
